<!-- Created by Kalpesh at 20-9-2021 -->

<div class="topDiv" style="margin-top: 70px; height: 90vh;overflow:auto;z-index:0">
    <div class="agGridOuterDiv" style="padding-left: 10px;padding-right:10px; height: 100%;">
        <div class="PlansHeaderDiv">
            <h4>Plans and Features Configuration</h4>
        </div><br>

        <div class="row" style="margin-top: 1%;">
            <div style="width: 4%;"></div>
            <div style="width: 25%;">
                <div class="seperateDiv">
                    <ag-grid-angular id="planGrid" class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin" [rowData]="rowDataForPlans" [columnDefs]="columnDefsForPlans"  [animateRows]="true"  [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="true"
                    [rowSelection]="rowSelectionForPlans" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true" (gridReady)="onGridReadyForPlans($event)" (cellClicked)="cellClickedPlan($event)" [hidden]="!true">
                    </ag-grid-angular>
                </div>
            </div>
            <div style="width: 1%;"></div>
            <div style="width: 65%;">
                <div class="seperateDiv">
                    <ag-grid-angular id="featuresGrid" class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin" [rowData]="rowData" [columnDefs]="columnDefsForFeatures"  [animateRows]="true"  [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="true" [suppressRowClickSelection]="true"
                    [rowSelection]="rowSelectionForFeatures" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true" (gridReady)="onGridReadyForFeatures($event)" (rowSelected)="onRowSelected($event)" [hidden]="!true">
                    </ag-grid-angular>
                </div>
            </div>
            <div style="width: 4%;"></div>
        </div>

        <div style="text-align: center; margin-top: 2%;">
            <button i18n="@@TMRunButton"  type="button" (click)="save()" class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            style="padding-left:1.2rem;padding-right: 1.2rem; width: 110px;" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">Save</button>
        </div>

    </div>
</div>
